document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-image-slider]').forEach(function (sliderEl) {
    var images = sliderEl.querySelectorAll('.card__slide-image');
    if (images.length < 2) return;

    var hoverTarget = sliderEl.closest('.card-wrapper') || sliderEl.closest('.card') || sliderEl;

    var currentIndex = 0;
    var intervalId = null;
    var displayTime = 3000;

    function resetPositions() {
      clearInterval(intervalId);
      images.forEach(function (img, i) {
        img.classList.toggle('is-active', i === 0);
      });
      currentIndex = 0;
    }

    function nextSlide() {
      var current = images[currentIndex];
      var nextIndex = (currentIndex + 1) % images.length;
      var next = images[nextIndex];

      current.classList.remove('is-active');
      next.classList.add('is-active');

      currentIndex = nextIndex;
    }

    hoverTarget.addEventListener('mouseenter', function () {
      intervalId = setInterval(nextSlide, displayTime);
    });

    hoverTarget.addEventListener('mouseleave', resetPositions);
  });
});